export class LendingAPIError extends Error {
    data: any;

    constructor(data: any) {
        super('Lending API Error');

        this.data = data;
    }
}

export function getErrorDetail(error: unknown): string {
    if (error instanceof LendingAPIError) {
        const status = error.data?.meta?.status;
        const detail = error.data?.data?.errors?.[0]?.detail;
        return detail ? `${status} ${detail}` : `${status || 'unknown'}`;
    }

    if (
        typeof error === 'object' &&
        error !== null &&
        'statusCode' in error &&
        typeof (error as { statusCode: unknown }).statusCode === 'number'
    ) {
        const { statusCode, message } = error as {
            statusCode: number;
            message: string;
        };
        return `${statusCode} ${message}`;
    }

    if (error instanceof Error) {
        return `network error: ${error.message || 'unknown'}`;
    }

    return 'unknown';
}
